import { useTranslation } from "react-i18next";
import { ErrorText } from "../../../components/error-text";
import { Required } from "../../../components/required";

interface Props {
    name: string;
    label?: string;
    required?: boolean;
    errorMessage?: string;
    className?: string;
    children?: React.ReactNode;
}

export default function LabelledField({
    name,
    className,
    children,
    label,
    required,
    errorMessage,
}: Props) {
    const { t } = useTranslation();

    return (
        <div className={className}>
            {label && (
                <div className="row">
                    <div className="col-auto font-size-16 mb-2">
                        {t(label)}
                        {required && <Required />}
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col-12">{children}</div>
            </div>
            {errorMessage && (
                <div className="row field-error" data-name={name}>
                    <div className="col-12">
                        <ErrorText text={t(errorMessage)} />
                    </div>
                </div>
            )}
        </div>
    );
}
